import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectService} from '../../services/project.service';

type projectType = {id: number, title: string, note: string, isHidden: boolean, items: projectItemType};
type projectItemType = Array<{id: number, title: string, isChecked: boolean, isHidden: boolean, items?: projectItemType}>;

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.css']
})
export class ProjectComponent implements OnInit {
  selectedItem: number = 0;
  selectedItemID: number = 0;
  projectName: string = "";
  itemName: string = "";
  newItemName: string = '';
  newPostName: string = '';
  newSubItemName: string = ''; 
  editedPost: boolean = false;
  editedItem: number = -1;
  editedItemID: string = '';
  isAddedItem: boolean = false;
  selectedSubItem: number = 0;
  unitValue: number = 1;
  newUnitValue: number = 1;
  newUnitSubValue: number = 1;

  //project: projectType;

  orderedProjectItem = -1;
  orderedProjectSubItem = -1;

  editedProject = {
    id: "",
    settings: 0,
    title: "",
    unit: "",
    idUser: localStorage.getItem("idUser"),
    state: 0
  };

  constructor(private route: ActivatedRoute, private projectService: ProjectService) {

   }

  ngOnInit() {
    this.projectService.editedMode = false;
    this.projectService.percentualProgress = 0;
    this.projectService.idProject = this.route.snapshot.paramMap.get('id');
    this.projectService.getProject();
  }

  selectItem(i, itemID){
    this.selectedItem = i;
    this.selectedItemID = itemID;
  }

  addItem(){
    this.projectService.addItem(this.itemName, this.newUnitValue);
    this.projectService.progressCount();
    this.itemName = "";
  }

  addSubItem(){
    this.projectService.addSubItem(this.selectedItem, this.selectedItemID, this.newSubItemName, this.newUnitSubValue);
    this.projectService.progressCount();
    this.itemName = "";
    this.newSubItemName = "";

  }

  hideItem(i){
    this.projectService.hideItem(i);
  }
  
  editProject(){
    this.editedProject.id = this.projectService.project.id;
    this.editedProject.title = this.projectService.project.title;
    this.editedProject.settings = this.projectService.project.settings;
    this.editedProject.unit = this.projectService.project.unit;

  }

  updateProject(){
    this.projectService.updateProject(this.editedProject);
    this.itemName = "";
    this.newSubItemName = "";
  }

  editItem(i){
    this.editedItem = i;
    this.itemName = this.projectService.project.items[i].title;
    this.unitValue = this.projectService.project.items[i].unitValue;
  }
  updateItem(){
    this.projectService.updateItemName(this.editedItem, this.itemName,this.unitValue);
    this.projectService.progressCount();
    this.editedItem = -1;
    this.itemName = "";
    this.newSubItemName = "";
  }

  editSubItem(i, j, id){
    this.selectedItem = i;
    this.selectedSubItem = j;
    this.editedItemID = id;
    this.newItemName = this.projectService.project.items[i].items[j].title;
    this.unitValue = this.projectService.project.items[i].items[j].unitValue;
  }
  updateSubItem(){
    this.projectService.updateSubItemName(this.selectedItem,this.selectedSubItem,this.newItemName,this.unitValue);
    this.projectService.progressCount();
    this.editedItem = -1;
    this.itemName = "";
    this.newSubItemName = "";
  }

  toggleCheckbox(i){
    this.projectService.toggleCheckbox(i);
    this.projectService.progressCount();
  }

  toggleSubCheckbox(i,j){
    this.projectService.toggleSubCheckbox(i,j);
    this.projectService.progressCount();
  }

  removeItem(i, id){
    this.projectService.removeItem(i, id);
    this.projectService.progressCount();
  }

  removeSubItem(i, j, id){
    this.projectService.removeSubItem(i,j,id);
    this.projectService.progressCount();
  }

  updateNote(){
    this.projectService.updateNote(this.newPostName);
    this.editedPost = false;

  }
  editNote(){
    this.newPostName = this.projectService.project.note;
    this.editedPost = true;
  }

  dropSuccess(i){
    this.orderedProjectItem = -1;
    this.projectService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedProjectItem = i;
  }

  dragEnd(){
    this.orderedProjectItem = -1;
  }

  dropSuccessSub(i,j){
    this.orderedProjectItem = -1;
    this.orderedProjectSubItem = -1;
    this.projectService.changeOrderSub(i,j+1);
  }

  dragStartSub(i,j){
    this.orderedProjectItem = i;
    this.orderedProjectSubItem = j;
  }

  dragEndSub(){
    this.orderedProjectItem = -1;
    this.orderedProjectSubItem = -1;
  }

  swapMode(){
    this.projectService.editedMode = !this.projectService.editedMode;
  }
  
  orderUp(i){
    this.projectService.orderUp(i);
  }
  orderDown(i){
    this.projectService.orderDown(i);
  }
  orderSubUp(i,j){
    this.projectService.orderSubUp(i,j);
  }
  orderSubDown(i,j){
    this.projectService.orderSubDown(i,j);
  }

}
 


// WEBPACK FOOTER //
// ./src/app/components/project/project.component.ts